<template>
  <!-- 修改字典对话框 -->
  <el-dialog
    title="修改用户"
    :visible.sync="editDialogVisible"
    width="60%"
    append-to-body
  >
    <el-form ref="editFormRef" :rules="rules" :model="editForm" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="账号" prop="username">
            <el-input v-model="editForm.username" disabled placeholder="请输入账号" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="用户名字" prop="name">
            <el-input v-model="editForm.name" placeholder="请输入用户名字" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="性别">
            <el-select v-model="editForm.sex" clearable placeholder="请选择性别" style="width: 100%">
              <el-option key="MAN" label="男" value="MAN"></el-option>
              <el-option key="WOMAN" label="女" value="WOMAN"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="电话" prop="phone">
            <el-input v-model="editForm.phone" placeholder="请输入电话" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="地址">
            <el-input v-model="editForm.address" placeholder="请输入地址" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="状态" prop="enumStatus">
            <el-select v-model="editForm.enumStatus" clearable placeholder="请选择状态" style="width: 100%">
              <el-option key="NORMAL" label="正常" value="NORMAL"></el-option>
              <el-option key="DISABLE" label="禁用" value="DISABLE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--<el-col :span="12">
          <el-form-item label="用户类型" prop="enumType">
            <el-select v-model="editForm.enumType" clearable placeholder="请选择用户类型" style="width: 100%">
              <el-option key="ADMIN" label="管理员" value="ADMIN"></el-option>
              <el-option key="NORMAL" label="普通用户" value="NORMAL"></el-option>
              <el-option key="INSIDE" label="超级管理员" value="INSIDE"></el-option>
            </el-select>
          </el-form-item>
        </el-col>-->

        <el-col :span="12">
          <el-form-item label="用户邮箱">
            <el-input v-model="editForm.email" placeholder="请输入用户邮箱" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="积分" prop="integral">
            <el-input v-model="editForm.integral" placeholder="请输入积分" />
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="是否是会员" prop="vip">
            <el-select v-model="editForm.vip" clearable placeholder="请选择是否是会员" style="width: 100%">
              <el-option key="YES" label="是" value="YES"></el-option>
              <el-option key="NO" label="否" value="NO"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="选择角色" prop="roleIds">
            <el-select v-model="editForm.roleIds" clearable placeholder="请选择是否是会员" style="width: 100%">
              <el-option v-for="item in roleList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <!--到期时间-->
        <el-col :span="12">
          <el-form-item label="到期时间" prop="expirationTime ">
            <el-date-picker
              v-model="editForm.expirationTime"
              type="date"
              value-format="timestamp"
              placeholder="选择到期时间">
            </el-date-picker>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="用户排序">
            <el-input v-model="editForm.sort" placeholder="请输入用户排序" />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="用户备注信息" prop="integral">
            <el-input v-model="editForm.brief" placeholder="用户备注信息" type="textarea" />
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="头像">
            <thumbnail-user @getFiles="getMd5" :autoCropWidth="200" :autoCropHeight="200" :fixedNumber="[1,1]"
                            :md5s="editForm.photo"></thumbnail-user>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button @click="modifyUser">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getByKey, updateUser } from '@/api/user/user'
import { getPostOrDeleteData } from '@/utils/code'
import ThumbnailUser from '@/components/common/thumbnailUser/thumbnailUser'
import { baseURL } from '@/utils/getawayModule'
import { userRules } from '@/js/rules'

export default {
  name: 'editUser',
  components: { ThumbnailUser },
  data() {
    return {
      editForm: {}, //修改
      editDialogVisible: false,
      // 规则
      rules: userRules,
      roleList: []
    }
  },
  created() {
    this.getRoleId()
  },
  methods: {
    //获取头像
    getMd5(obj) {
      let url = `${baseURL.userApi}/file/${obj.md5}/download`
      const protocol = window.location.protocol
      const host = window.location.host
      this.editForm.photo = protocol + '//' + host + url
    },

    //获取角色id
    getRoleId() {
      getByKey().then(res => {
        this.roleList = res.data
      })
    },

    cancel() {
      this.editDialogVisible = false
      this.editForm = {}
    },

    editDialog(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.editDialogVisible = true
    },

    modifyUser() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return
        delete this.editForm.enumType
        delete this.editForm.roleNames
        updateUser(this.editForm.id, this.editForm).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.editDialogVisible = false
          }
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-input {
  width: 90%;
}
</style>
